import moment from 'moment'
import { types } from "../action-types";

const initialState = {
  loading: false,
  notification: [],
  notificationCount: 0,
  error: false,
  updateRequested: false,
  notificationUnreadCount:0,
};

const fetchNotificationReducer = (state = initialState, action) => {
  let notiCount = state.notificationCount;
  let notiPrev = state.notification;
  switch (action.type) {
    case types.GET_NOTIFICATION_REQUESTED:
      if(action.payload?.fetchMore){
        return {
          ...state,
          loading: true,
        };
      }
      else{
        return {
          ...state,
          loading: action.payload?.fromSocket ? false : true,
          notification: notiPrev,
          notificationCount: notiCount
        };
      }

    case types.GET_NOTIFICATION_SUCCESS:
      // const data = action.payload
      // const isarray = Array.isArray(notification)
      // const notifications = isarray ? notification?.filter(n => n != data) : notification
      // console.log('notification success', action.payload, notification)
      let combineArr = state.notification.concat(action.payload.notification).reverse()
      combineArr.sort((a, b) => moment(b.Created) - moment(a.Created));
      return {
        ...state,
        loading: false,
        notification: [...new Set(combineArr.map(item => item._id))].map(id => {
          return combineArr.find(item => item._id === id)
        }),
        notificationCount: action.payload.NotifictionCount,
        notificationUnreadCount: action.payload.NotifictionUnreadCount,
        error: false,
      };
    case types.GET_NOTIFICATION_FAILURE:
      return {
        ...state,
        loading: false,
        notification: [],
        error: true,
      };

      case types.READ_NOTIFICATION:
      return {
        ...state,
        updateRequested: true,
        // loading: true,
      };

    case types.READ_NOTIFICATION_SUCCESS:      
      return {
        ...state,        
        updateRequested: false,
        error: false,
      };
    case types.READ_NOTIFICATION_FAILURE:
      return {
        ...state,
        loading: false,
        //notification: [],
        error: true,
      };
    default:
      return state;
  }
};

export default fetchNotificationReducer;
